import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { AccessControlProfile } from '../../api/types/access-control-profile';

import { Scrollbar } from '@/components/atoms/scrollbar';
import { DataStatusIndicator } from '@/components/molecules/data-status-indicator/data-status-indicator';

interface Props {
  data: AccessControlProfile[];
  error: string;
  isLoading: boolean;
}

export const AccessControlProfilesTable = ({ data, error, isLoading }: Props) => {
  const { t } = useTranslation(['accessControlProfiles']);

  const columns = [
    {
      id: 'name',
      label: t('accessControlProfiles:name'),
    },
    {
      id: 'createdAt',
      label: t('accessControlProfiles:createdAt'),
    },
    {
      id: 'updatedAt',
      label: t('accessControlProfiles:updatedAt'),
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
      }}>
      <Scrollbar>
        <Table sx={{ minWidth: 1000 }}>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map(acp => (
              <TableRow hover key={acp.id}>
                <TableCell>{acp.name}</TableCell>
                <TableCell>
                  <Typography color="inherit" variant="inherit">
                    {format(new Date(acp.createdAt), 'dd MMM yyyy')}
                  </Typography>
                  <Typography color="textSecondary" variant="inherit">
                    {format(new Date(acp.createdAt), 'HH:mm')}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="inherit" variant="inherit">
                    {format(new Date(acp.updatedAt), 'dd MMM yyyy')}
                  </Typography>
                  <Typography color="textSecondary" variant="inherit">
                    {format(new Date(acp.updatedAt), 'HH:mm')}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Scrollbar>
      <DataStatusIndicator dataLength={data?.length} error={error} isFetching={isLoading} />
    </Box>
  );
};
